import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import colors from 'themes/_variables.module.scss';
import SemDados from '../SemDados';

const CanalSolicitacao = (props) => {
  const { data } = props;
  const titulo = 'RANK SOLICITAÇÕES POR CANAL';

  if (!data || data.length < 1) {
    return <SemDados titulo={titulo} />;
  }

  const itens = data.map((item) => {
    return item.nome;
  });

  const itensPorcentagem = data.map((item) => {
    return item.porcentagem;
  });

  const itensQtd = data.map((item) => {
    return item.total;
  });

  const itensQtdAprovado = data.map((item) => {
    return item.totalAprovado;
  });

  const series = [
    {
      data: itensPorcentagem,
    },
  ];

  const options = {
    colors: [colors.secondary],
    plotOptions: {
      bar: {
        barHeight: '80%',
        horizontal: true,
        dataLabels: {
          position: 'top',
          orientation: 'horizontal',
        },
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
      categories: itens,
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      max: Math.max(...itensPorcentagem) * 1.25,
      labels: {
        align: 'right',
        maxWidth: 120, // alterar para mudar o tamanho do espaco para as categorias
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
        },
      },
    },
    grid: {
      padding: {
        left: 20,
      },
      row: {
        colors: ['#dcdcdc', 'transparent'],
        opacity: 0.5,
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      parentHeightOffset: 0,
      width: '100%',
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'start',
      offsetX: 5,
      offsetY: 6,
      formatter: (value) => {
        return `${value}%`;
      },
      style: {
        fontSize: '0.75rem',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      intersect: false,
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              <span id="data">${itens[dataPointIndex]}</span>
            </span>
            <span>
              Total de Solicitações: <span id="data">${itensQtd[dataPointIndex]}</span>
            </span>
            <span>
            Total de Solicitações Aprovadas: <span id="data">${itensQtdAprovado[dataPointIndex]}</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico" style={{ overflow: 'hidden' }}>
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <div className="scrollable">
        <Chart
          options={options}
          series={series}
          height={itens.length * 17 + 100}
          type="bar"
        />
      </div>
    </div>
  );
};

export default CanalSolicitacao;
